import { useSelectedSearchMode } from '#pplx/frontend/apps/ask/hooks/selected-search-mode-hooks/useSelectedSearchMode.js';
import { useThreadConfig } from '#pplx/frontend/apps/ask/providers/ThreadSettingsProviderShared.js';
import { useLocalUserSettings } from '#pplx/frontend/apps/ask/user-settings/getLocalUserSettings.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useCallback } from 'react';
export function useHomeComposerAcceptedSubmit() {
    const selectedSearchMode = useSelectedSearchMode();
    const { askDeepResearchModel } = useThreadConfig();
    const [, setLastSubmittedAskInputMode] = useLocalUserSettings('lastSubmittedAskInputMode', undefined);
    return useCallback(() => {
        setLastSubmittedAskInputMode(selectedSearchMode === SearchMode.ASI && !askDeepResearchModel ? 'computer' : 'search');
    }, [askDeepResearchModel, selectedSearchMode, setLastSubmittedAskInputMode]);
}
//# sourceMappingURL=useHomeComposerAcceptedSubmit.js.map